import { render, staticRenderFns } from "./ReminderEmailTemplatePropSelect.vue?vue&type=template&id=c862958a"
import script from "./ReminderEmailTemplatePropSelect.vue?vue&type=script&lang=ts"
export * from "./ReminderEmailTemplatePropSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c862958a')) {
      api.createRecord('c862958a', component.options)
    } else {
      api.reload('c862958a', component.options)
    }
    module.hot.accept("./ReminderEmailTemplatePropSelect.vue?vue&type=template&id=c862958a", function () {
      api.rerender('c862958a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/ReminderEmailTemplatePropSelect.vue"
export default component.exports